import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
import { OrgChart } from 'd3-org-chart';
import styles from "../styles/CompanyTree.module.css";
import * as d3 from "d3"
import { MinusCircleOutlined, MinusCircleTwoTone, PlusCircleOutlined, PlusCircleTwoTone } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
const CompanyTreeOrganization = ({
  departmentList = [],
  lang = "",
  companyInformation = {},
  graphRef = null
}) => {
  const { t } = useTranslation();
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);

  // console.log("departmentList", transformData(departmentList));

  // Ensure that root data is structured properly
  // const rootData = [
  //   { id: 100, parentId: null, name: 'Steven King', position: 'Chief Operating Officer', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait12.png', email: 'SKING', phone_number: '515.123.4567', hire_date: '2003-07-16T19:00:00.000Z' },
  //   { id: 101, parentId: 100, name: 'Neena Kochhar', position: 'Administration Vice President', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait85.png', email: 'NKOCHHAR', phone_number: '515.123.4568', hire_date: '2005-10-20T20:00:00.000Z' },
  //   { id: 102, parentId: 100, name: 'Lex De Haan', position: 'Administration Vice President', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait16.png', email: 'LDEHAAN', phone_number: '515.123.4569', hire_date: '2001-02-12T20:00:00.000Z' },
  //   { id: 103, parentId: 100, name: 'Alexander Hunold', position: 'Programmer', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait17.png', email: 'AHUNOLD', phone_number: '590.423.4567', hire_date: '2006-02-02T20:00:00.000Z' },
  //   { id: 104, parentId: 103, name: 'Bruce Ernst', position: 'Programmer', image: 'https://bumbeishvili.github.io/avatars/avatars/portrait18.png', email: 'BERNST', phone_number: '590.423.4568', hire_date: '2007-06-20T20:00:00.000Z' }
  // ];

  function transformData(data, lang) {

    const result = [{
      id: 'root', preventExpand: true, parentId: null
      , name: companyInformation?.['companyName' + (lang == 'en' ? "En" : "")], position: ""
      , image: 'https://bumbeishvili.github.io/avatars/avatars/portrait12.png',
      email: 'SKING', phone_number: '515.123.4567', hire_date: '2003-07-16T19:00:00.000Z'
    }];

    function traverse(node, parentId = null) {
      const transformedNode = {
        id: node.organizationId || node.id,
        parentId: parentId || 'root',
        name: node?.['organizationName' + (lang == 'en' ? "En" : "")] || node.name,
        position: node.organizationLevel?.name || 'Unknown Position',
        image: node.image || '',
        email: node.email || '',
        phone_number: node.phone_number || '',
        hire_date: node.hire_date || '',
        preventExpand: true
      };

      result.push(transformedNode);

      if (node.children && node.children.length > 0) {
        node.children.forEach(child => traverse(child, transformedNode.id));
      }
    }
    data.map(o => traverse(o))
    return result;
  }

  useEffect(() => {
    // Log root data for debugging

    // Check if the root data is valid
    const chartContainer = chartRef.current;

    // Ensure chart container is available
    if (!chartContainer) {
      console.error("Chart container is not available.");
      return;
    }
    // Initialize OrgChart only after container is available
    const orgChart = new OrgChart()
      .nodeHeight((d) => 50 + 25)
      .nodeWidth((d) => 350 + 2)
      .childrenMargin((d) => 150)
      .compactMarginBetween((d) => 200)
      .compactMarginPair((d) => 200)
      .neighbourMargin((a, b) => 200)
      // .scaleExtent([1, 1])
      // .scaleExtent([0.3, 1])
      .buttonContent(() => { })
      .nodeContent(function (d) {
        const color = '#FFFFFF';
        // const imageDiffVert = 25 + 2;
        return `
          <div id='node-na' style="width:${d.width}px;height:${d.height}px;padding-left:1px;padding-right:1px;">
            <div style=";background-color:${color};margin-left:-1px;width:${d.width - 2}px;border-radius:100px;border: 1px solid black ;padding-left :20px;padding-right :20px;">
              <div style="min-height:${d.height}px;align-content:center;font-size:1.3vw;color:#08011E;text-align:center ;white-space: normal; word-wrap: break-word; overflow: hidden; text-overflow: ellipsis;">${d.data?.name}</div>
            </div>
          </div>`;
      })
      .container(chartContainer)
      .data(transformData(departmentList, lang))
      .render();
    // Set chart to state for future manipulation (optional)

    // Styling the connections with custom arrowheads
    const svg = d3.select(chartContainer).select("svg");

    if (svg) {
      const defs = svg.append("defs");

      svg.selectAll(".node")
        .style("cursor", "default");

    }
    orgChart?.expandAll()
    orgChart?.compact?.(false).render();
    // Disable the expand/collapse button specifically
    orgChart?.nodeButtonWidth((node) => node.data?.preventExpand ? 0 : 20)
      .nodeButtonHeight((node) => node.data?.preventExpand ? 0 : 20);
    const rootNodeId = departmentList[0]?.id; // Assuming the first item is the root
    if (rootNodeId) {
      orgChart.setCentered(rootNodeId);
    }

    setChart(orgChart);
    // Cleanup on component unmount
    return () => {
      if (chart) {
        chart?.destroy?.();
      }
    };
  }, [departmentList, companyInformation, lang]);

  useEffect(() => {
    console.log("chart");

    graphRef.current = chart
  }, [chart])


  return (
    <div>
      <div className={styles.stylesNode}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', gap: "12px" }}>
          {/* <Button onClick={() => (exportAndSaveImage(chart))} style={{ marginRight: 10 }}>
            Download
          </Button> */}
          <Button onClick={() => {
            chart.nodeHeight(() => 125 + 25);
            chart.layout('left').render().fit()
          }}>
            {t("og_chart.left")}
          </Button>
          <Button onClick={() => {
            chart.nodeHeight(() => 50 + 25);
            chart.layout('top').render().fit()
          }}>
            {t("og_chart.top")}
          </Button>
        </div>
        <div id="apexTreeWrapper" style={{ width: "100%" }} ref={chartRef} className="chart-container"></div>
      </div>
    </div>
  );
};

export default CompanyTreeOrganization;
